import { render } from "./EmployerAuth.vue?vue&type=template&id=b22b98b6&ts=true"
import script from "./EmployerAuth.vue?vue&type=script&lang=ts"
export * from "./EmployerAuth.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__